export default __webpack_public_path__ + "static/media/logo.dfc729c4.png";